import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';
import { NumberUtils } from '@/utils/number.utils';
import i18n from '@/i18n';

export const DEFAULT_ICON_URL = 'https://s3-ap-northeast-1.amazonaws.com/grow-asset/user_icons/default.png';

// 生徒カルテデータ
export class StudentKarte implements Serializable<StudentKarte> {
  big5Scores: Big5Score[];
  learningIncentive: string = '';
  learningStyle: string = '';
  motivation: string = '';

  deserialize(input: any): StudentKarte {
    this.big5Scores = input.big5Scores.map((big5Score: Big5Score) => new Big5Score().deserialize(big5Score));

    if (input.motivation !== '') {
      this.motivation = input.motivation;
    } else {
      this.learningIncentive = i18n.t('LEARNING_INCENTIVE_2').toString();
    }
    if (input.learningIncentive !== '') {
      this.learningIncentive = input.learningIncentive;
    } else {
      this.motivation = i18n.t('LEARNING_INCENTIVE_3').toString();
    }
    if (input.learningStyle !== '') {
      this.learningStyle = input.learningStyle;
    } else {
      this.learningStyle = i18n.t('LEARNING_INCENTIVE_1').toString();
    }

    return this;
  }
}

export class Big5Score implements Serializable<Big5Score> {
  advice: string;
  big5ID: number;
  description: string;
  highScoreTitle: string;
  iconUrl: string;
  isTutorial: boolean;
  lowScoreTitle: string;
  score: number;
  tested: boolean;
  title: string;
  typeKey: string;

  deserialize(input: any): Big5Score {
    this.advice = input.advice;
    this.big5ID = input.big5ID;
    this.description = input.description;
    this.highScoreTitle = input.highScoreTitle;
    this.iconUrl = DEFAULT_ICON_URL;
    this.isTutorial = input.isTutorial;
    this.lowScoreTitle = input.lowScoreTitle;
    this.score = input.score;
    this.tested = input.tested;
    this.title = input.title;
    this.typeKey = input.typeKey;
    return this;
  }

  get scoreInt(): number {
    return NumberUtils.plusFloorAndMinusCeil(this.score * 50);
  }

  get color(): string {
    switch (this.big5ID) {
      case GEnum.Big5.ID1:
        return '#0050b3';
      case GEnum.Big5.ID2:
        return '#237804';
      case GEnum.Big5.ID3:
        return '#ad8b00';
      case GEnum.Big5.ID4:
        return '#391085';
      case GEnum.Big5.ID5:
        return '#a8071a';
    }
  }

  get karteBig5RowClass(): string {
    return 'big5-record-' + String(this.big5ID);
  }

  // 外向姓・開放性・繊細姓・協調性・自立性のスコアとして算出
  // 表示上、2桁の数字として表現したいので、計算後に小数点以下を切り捨てるが、
  // 50.35971543 などの場合、小数点以下を切り捨てると [ 50 ]
  // 小学生のスコア（手入力で基本0.5刻み）が 0 の場合も [ 50 ] となってしまう
  // わずかでも 50 より上であり、51 未満であれば、51 とする、という仕様になっています
  get convertToEelementaryScore(): number {
    const tmpScore: number = (this.score * 25) + 50;
    if (tmpScore > 50 && tmpScore < 51) {
      return 51;
    }
    return Math.floor(tmpScore);
  }

  get elementaryScoreHigh(): number {
    return this.convertToEelementaryScore;
  }

  // 内向性・保守性・平穏姓・独立性・自由性のスコアは、
  // 100をマックスとして、外向姓・開放性・繊細姓・協調性・自立性のスコアの逆
  // 例 : 外向性 = 0.8 であった場合
  //      (0.8 * 25) + 50 = 70
  //      100 - 70 = 30 => [内向性 : 30]
  get elementaryScoreLow(): number {
    return 100 - this.convertToEelementaryScore;
  }

  get isScore50(): boolean {
    return this.elementaryScoreHigh == this.elementaryScoreLow;
  }

  get superiorityHigh(): boolean {
    return this.elementaryScoreHigh >= this.elementaryScoreLow;
  }

  get superiorityLow(): boolean {
    return this.elementaryScoreHigh < this.elementaryScoreLow;
  }
}
